import { SelectOption } from '../models';

export enum Participant {
  ME = 0,
  MANAGERS = 1,
  DRIVERS = 2,
}

export const Participants: SelectOption[] = [
  { value: Participant.ME, label: 'Me' },
  { value: Participant.MANAGERS, label: 'Managers' },
  { value: Participant.DRIVERS, label: 'Drivers' },
];
